module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-left-up-c81942a7efb0dab799550cf4be917f29.svg";